<div class="flex flex-col gap-6">
  <bb-field label="Monitoring brief name" [required]="true" hint="You'll spot this in your dashboard later.">
    <input [value]="createMonitoringService.basicInfoModel().briefTitle"
      (input)="setTitle($any($event.target).value)" data-guide-id="monitoring.briefTitle"
      placeholder="e.g. Spring deliverables watch"
      class="w-full rounded-md border border-border bg-card px-3.5 py-2.5 text-base outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25 placeholder:text-muted-foreground" />
  </bb-field>

  <div class="flex flex-col gap-3">
    <div>
      <h3 class="font-heading text-base font-bold">Monitoring type</h3>
      <p class="mt-1 text-sm text-muted-foreground">Choose whether we look for brief content or brand-safety issues.</p>
    </div>
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
      @for (type of createMonitoringService.monitoringTypeOptions; track type.type) {
      <button type="button" (click)="selectType(type.type)"
        [attr.aria-pressed]="createMonitoringService.monitorType() === type.type"
        class="h-full rounded-xl border p-4 text-left transition-colors"
        [class]="createMonitoringService.monitorType() === type.type ? 'border-brand-studio bg-brand-studio/10 ring-2 ring-brand-studio/25' : 'border-border bg-card hover:border-foreground/30'">
        <p class="text-sm font-semibold text-foreground">{{ type.name }}</p>
        <p class="mt-1 text-xs text-muted-foreground">{{ type.description }}</p>
      </button>
      }
    </div>
  </div>

  <!-- <div class="flex flex-col gap-2">
    <h3 class="font-heading text-base font-bold">What to watch for</h3>
    <p class="text-sm text-muted-foreground">Describe the content this brief should catch. This is sent as the brief overview.</p>
    <atom-wysiswyg [inputHtml]="createMonitoringService.briefTextHtml()" placeholder="Describe the content to watch for"
      (htmlContentChange)="onBriefText($event)"></atom-wysiswyg>
  </div> -->
</div>
